import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { SearchEntity } from "shared";

export const SEARCH_PAGE_SIZE = 20;

export type SearchResponse = ClientInferResponseBody<typeof contract.search.search, 200>;
export type SearchResult = SearchResponse["data"][number];

export const fetchSearch = async ({
  query,
  entity,
  page,
}: {
  query: string;
  entity?: SearchEntity;
  page: number;
}): Promise<SearchResponse> => {
  const response = await api.search.search.query({
    query: {
      query,
      page,
      ...(entity ? { entity } : {}),
    },
  });

  if (response.status !== 200) {
    throw new Error("Search request failed");
  }

  return response.body;
};
